import axiosInstance from '../lib/axios';

export interface CommentUser {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  employeeId?: string;
  profilePicture?: string | null;
}

export interface Comment {
  _id: string;
  task: string;
  content: string;
  createdBy: CommentUser;
  updatedBy?: CommentUser;
  createdAt: string;
  updatedAt: string;
}

export interface CreateCommentRequest {
  content: string;
  taggedUsers?: string[];
}

export interface UpdateCommentRequest {
  content: string;
}

class CommentService {
  private baseUrl = '/tasks';

  // GET all comments for a task
  async getCommentsByTask(taskId: string): Promise<Comment[]> {
    try {
      const response = await axiosInstance.get<Comment[]>(`${this.baseUrl}/${taskId}/comments`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching comments for task ${taskId}:`, error);
      throw error;
    }
  }

  // POST create a new comment
  async createComment(taskId: string, commentData: CreateCommentRequest): Promise<Comment> {
    try {
      const response = await axiosInstance.post<Comment>(
        `${this.baseUrl}/${taskId}/comments`,
        commentData
      );
      return response.data;
    } catch (error) {
      console.error(`Error creating comment for task ${taskId}:`, error);
      throw error;
    }
  }

  // PATCH update an existing comment
  async updateComment(
    taskId: string,
    commentId: string,
    commentData: UpdateCommentRequest
  ): Promise<Comment> {
    try {
      const response = await axiosInstance.patch<Comment>(
        `${this.baseUrl}/${taskId}/comments/${commentId}`,
        commentData
      );
      return response.data;
    } catch (error) {
      console.error(`Error updating comment ${commentId}:`, error);
      throw error;
    }
  }

  // DELETE a comment
  async deleteComment(taskId: string, commentId: string): Promise<void> {
    try {
      await axiosInstance.delete(`${this.baseUrl}/${taskId}/comments/${commentId}`);
    } catch (error) {
      console.error(`Error deleting comment ${commentId}:`, error);
      throw error;
    }
  }
}

export const commentService = new CommentService();
export default commentService;

